import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbBlocoPsim } from 'app/abstract/full-pages/config-psim/bloco-psim.abstract';

@Injectable({ providedIn: 'root' })
export class BlocoPSIMService extends AbBlocoPsim {

  constructor(http: HttpClient) {
    super(http);
  }

  public findAll() {
    return this.get(`bloco_psims/all`).toPromise().catch();
  }

  public salvar(lista: any): Observable<any> {
    return this.save(`bloco_psims/savelist`, lista);
  }
}
